import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { Button, Container, SpacerRow } from '@zg-rentals/multibrand-ui';
import Section from '@rental-manager/components/Section';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import EmptyLeaseIcon from '@assets/rental-protection-empty-lease-icon.svg';
import ExpandableDisclaimer from '@common/components/ExpandableDisclaimer';
import type { IStyledTextModel } from '@rental-manager/models/Types';
import StringConstants from '@common/constants/StringConstants';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

type RentalProtectionDisclaimers = Array<IStyledTextModel>;

type Props = {
  onClose: () => void;
  onBack: () => void;
  goToSetupPaymentManually: () => void;
  propertyId: string;
  rentalProtectionDisclaimers: RentalProtectionDisclaimers;
  listingAlias: string;
};

const EmptyLeasePage: React.FC<React.PropsWithChildren<Props>> = (props: Props): React.ReactElement => {
  const { listingAlias, propertyId } = props;
  const managePolicyUrl = StringConstants.LINKS.RENTAL_PROTECTION.MANAGE_POLICY_PAGE(listingAlias);

  const goToCreateLease = () => {
    window.location.href = StringConstants.LINKS.GO_TO_LEASES(propertyId);
  };

  const goToSetupPaymentManually = () => {
    props.goToSetupPaymentManually();
  };

  return (
    <Modal
      persona={userPersonas.LANDLORD}
      header="Payment setup"
      onClickBack={props.onBack}
      onRequestClose={props.onClose}
      dataAutoTestId="landlord-empty-lease-modal"
    >
      {
        <Container>
          <Section>
            {/* oxlint-disable-next-line next/no-img-element -- not a Next.js app (no next dependency, custom SSR server) */}
            <img src={EmptyLeaseIcon as unknown as string} alt="" className="centeredImg" />
          </Section>
          <Section>
            <Text type="h4" className="txtC zillowInsuranceSubHeading" emphasize>
              Zillow Insurance Services
            </Text>
          </Section>
          <Section>
            <Text type="h4" className="txtC boldText">
              An eligible lease is required for Rental Protection
            </Text>
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <Text>
              <strong>You don&apos;t have any leases to connect with payments yet.&nbsp;</strong>
              If you still want to request{' '}
              <Link escape={false} target="_blank" to={managePolicyUrl} type="secondary">
                Rental Protection
              </Link>{' '}
              through Zillow Insurance Services, you&apos;ll need to create or upload a signed lease to set up payments.
            </Text>
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <ExpandableDisclaimer disclaimerContent={props.rentalProtectionDisclaimers} title="Legal Disclaimer" />
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <Button type="primary" onClick={goToCreateLease} full>
              Add lease
            </Button>
          </Section>
          <Section>
            <Button type="secondary" onClick={goToSetupPaymentManually} style={{ border: 0 }} full>
              Set up payments without lease
            </Button>
          </Section>
        </Container>
      }
    </Modal>
  );
};

export default EmptyLeasePage;
